export default __webpack_public_path__ + "static/media/sv5_en_head_a1.aad1d7ed.mp3";